import Buttons from './components/buttons.js'
import './App.css';

function App() {
  return (
    <div className="wrapper">
      <div id="main">
        <Buttons />
      </div>
    </div>
  );
}

export default App;
